import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-dynamic-table',
  templateUrl: './dynamic-table.component.html',
  styleUrls: ['./dynamic-table.component.scss']
})
export class DynamicTableComponent {
  @Input() displayedColumns: string[] = [];
  @Input() labels: string[] = [];
  @Input() dataSource: any[] = [];
  @Input() columnNumber = 0;
}
